<template>
  <div class="download-home-page">
    <!-- Header -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo" @click="goHome">
          <!-- <el-icon class="logo-icon">
            <Document />
          </el-icon> -->
          <span class="logo-text">51软件下载</span>
        </div>
        <el-menu 
          mode="horizontal" 
          class="nav-menu" 
          background-color="transparent" 
          text-color="#1890ff"
          active-text-color="#1890ff"
          :default-active="activeMenu"
          @select="handleMenuSelect"
          :ellipsis="false"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/about">关于我们</el-menu-item>
          <el-menu-item index="/feedback">意见反馈</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-left">
          <div class="tagline">极速下载  畅享无限</div>
          <h1 class="hero-title">专业的软件下载平台<br><span class="highlight">为您提供一站式服务</span></h1>
          <p class="hero-description">
            我们提供安全、可靠、高速的软件下载服务，涵盖各类常用软件和工具。
            通过智能下载技术和优质服务，让您的软件获取体验更加便捷高效。
          </p>
          <div class="hero-actions">
            <el-button type="primary" size="large" class="explore-btn">
              <el-icon><Search /></el-icon>
              浏览软件
            </el-button>
            <el-button type="success" size="large" class="safe-btn">
              <el-icon><Shield /></el-icon>
              安全下载
            </el-button>
          </div>
        </div>
        <div class="hero-right">
          <div class="software-showcase">
            <div class="software-card" v-for="(software, index) in featuredSoftware" :key="index" @click="goToIDMPage(software.name)">
              <img :src="software.icon" :alt="software.name" class="software-icon">
              <div class="software-info">
                <h3 class="software-name">{{ software.name }}</h3>
                <p class="software-version">{{ software.version }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Categories Section -->
    <div class="section categories-section">
      <div class="section-header">
        <h2 class="section-title">软件分类</h2>
        <p class="section-description">按类别查找您需要的软件</p>
      </div>
      
      <div class="categories-grid">
        <div class="category-card" v-for="(category, index) in categories" :key="index" @click="goToCategory(category)">
          <div class="category-icon">
            <el-icon :size="32"><component :is="category.icon" /></el-icon>
          </div>
          <h3 class="category-name">{{ category.name }}</h3>
          <p class="category-count">{{ category.count }} 款软件</p>
        </div>
      </div>
    </div>

    <!-- Featured Software Section -->
    <div class="section featured-section">
      <div class="section-header">
        <h2 class="section-title">热门推荐</h2>
        <p class="section-description">最受用户欢迎的软件</p>
      </div>
      
      <div class="featured-grid">
        <div class="software-item" v-for="(software, index) in featuredSoftwareList" :key="index">
          <div class="software-image">
            <img :src="software.icon" :alt="software.name">
          </div>
          <div class="software-details">
            <h3 class="software-name">{{ software.name }}</h3>
            <p class="software-desc">{{ software.description }}</p>
            <div class="software-meta">
              <span>版本: {{ software.version }}</span>
              <span>大小: {{ software.size }}</span>
            </div>
            <el-button type="primary" class="download-btn" @click="goToIDMPageV2(software.name)">
              <el-icon><Download /></el-icon>
              立即下载
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Advantages Section -->
    <div class="section advantages-section">
      <div class="section-header">
        <h2 class="section-title">我们的优势</h2>
        <p class="section-description">为什么选择我们的平台</p>
      </div>
      
      <div class="advantages-grid">
        <div class="advantage-card" v-for="(advantage, index) in advantages" :key="index">
          <div class="advantage-icon">
            <el-icon :size="32"><component :is="advantage.icon" /></el-icon>
          </div>
          <h3 class="advantage-title">{{ advantage.title }}</h3>
          <p class="advantage-description">{{ advantage.description }}</p>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <div class="cta-section">
      <h2>开始您的下载之旅</h2>
      <p>立即体验高速、安全、便捷的软件下载服务</p>
      <el-button type="primary" size="large" class="cta-button">
        <el-icon><Download /></el-icon>
        免费下载
      </el-button>
    </div>

    <!-- Footer -->
    <el-footer class="footer">
      <div class="footer-content">
        <p class="copyright">Copyright©2025 51softdown.cn All rights reserved.</p>
        <div class="footer-links">
          <span>奇安科技有限公司贵州分公司</span>
          <!-- <span>豫公网安备 XXXXXXXXXX号</span> -->
          <span>黔ICP备2026000902号-1</span>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { 
  Search, 
  Shield, 
  Download,
  // eslint-disable-next-line no-unused-vars
  Refresh,
  // eslint-disable-next-line no-unused-vars
  Service
} from '@element-plus/icons-vue'

// 路由相关
const route = useRoute()
const router = useRouter()

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  if (route.path === '/order-query') {
    return '/order-query'
  } else if (route.path === '/about') {
    return '/about'
  } else if (route.path === '/feedback') {
    return '/feedback'
  }
  return '/'
})

// 菜单选择处理
const handleMenuSelect = (key) => {
  if (key === '/') {
    router.push('/')
  } else if (key === '/order-query') {
    router.push('/order-query')
  } else if (key === '/about') {
    router.push('/about')
  } else if (key === '/feedback') {
    router.push('/feedback')
  }
}

// 返回首页
const goHome = () => {
  router.push('/')
}

// 跳转到分类
const goToCategory = (category) => {
  console.log('跳转到分类:', category.name)
}

// 跳转到IDM页面
const goToIDMPage = (softwareName) => {
  if (softwareName === 'IDM下载器') {
    router.push('/idm')
  }
  else if (softwareName === 'VMware Workstation Pro') {
    router.push('/vmware')
  }
}

// 跳转到IDM页面V2并滚动到顶部
const goToIDMPageV2 = (softwareName) => {
  if (softwareName === 'Internet Download Manager') {
    router.push('/idm')
  }
  else if (softwareName === 'VMware Workstation Pro') {
    router.push('/vmware')
  }

    // 跳转后滚动到页面顶部
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }, 100)
}

// 软件分类数据
const categories = ref([
  {
    name: '系统工具',
    count: 128,
    icon: 'Monitor'
  },
  {
    name: '媒体播放',
    count: 86,
    icon: 'VideoCamera'
  },
  {
    name: '图形图像',
    count: 72,
    icon: 'Picture'
  },
  {
    name: '安全软件',
    count: 45,
    icon: 'Lock'
  },
  {
    name: '网络工具',
    count: 93,
    icon: 'DataLine'
  },
  {
    name: '手机软件',
    count: 156,
    icon: 'Iphone'
  },
  {
    name: '办公软件',
    count: 67,
    icon: 'Files'
  },
  {
    name: '系统优化',
    count: 54,
    icon: 'Setting'
  }
])

// 特色软件展示数据
const featuredSoftware = ref([
  {
    name: 'IDM下载器',
    version: 'v6.42',
    icon: new URL('@/assets/idm.png', import.meta.url).href
  },
  {
    name: 'VMware Workstation Pro',
    version: 'v17.6',
    icon: new URL('@/assets/vmware.png', import.meta.url).href
  }/*,
  {
    name: 'WinRAR',
    version: 'v6.24',
    icon: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=100&h=100&q=80'
  },
  {
    name: 'Chrome浏览器',
    version: 'v118.0',
    icon: 'https://images.unsplash.com/photo-1547891654-e66ed7ebb968?auto=format&fit=crop&w=100&h=100&q=80'
  }*/
])

// 热门推荐软件数据
const featuredSoftwareList = ref([
  {
    name: 'Internet Download Manager',
    description: '强大的下载加速器，支持多线程下载和断点续传',
    version: '6.42',
    size: '12.5 MB',
    icon: new URL('@/assets/idm.png', import.meta.url).href
  },
  {
    name: 'VMware Workstation Pro',
    description: 'VMware是业界领先的桌面虚拟化软件',
    version: '2024',
    size: '401.4M',
    icon: new URL('@/assets/vmware.png', import.meta.url).href
  }/*,
  {
    name: 'WinRAR',
    description: '流行的压缩文件管理工具，支持多种压缩格式',
    version: '6.24',
    size: '3.2 MB',
    icon: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=100&h=100&q=80'
  },
  {
    name: 'Google Chrome',
    description: '快速、安全且免费的网页浏览器，全球用户首选',
    version: '118.0',
    size: '85.6 MB',
    icon: 'https://images.unsplash.com/photo-1547891654-e66ed7ebb968?auto=format&fit=crop&w=100&h=100&q=80'
  }*/
])

// 优势数据
const advantages = ref([
  {
    icon: 'Download',
    title: '极速下载',
    description: '通过多线程技术和智能加速，大幅提升下载速度'
  },
  {
    icon: 'Shield',
    title: '安全保障',
    description: '所有软件均经过严格检测，确保无病毒、无恶意插件'
  },
  {
    icon: 'Refresh',
    title: '断点续传',
    description: '支持中断恢复下载，网络不稳定也不怕'
  },
  {
    icon: 'Service',
    title: '专业技术支持',
    description: '提供专业的技术支持和售后服务，解决您的后顾之忧'
  }
])
</script>

<style scoped>
.download-home-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #e6f7ff 0%, #bae7ff 50%, #ffffff 100%);
}

/* Header Styles */
.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-icon {
  color: #1890ff;
  font-size: 28px;
}

.logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-menu {
  border: none;
  background: transparent !important;
}

.nav-menu .el-menu-item {
  font-weight: 500;
  padding: 0 20px;
  font-size: 16px;
  color: #1890ff !important;
}

.nav-menu .el-menu-item:hover {
  background-color: rgba(24, 144, 255, 0.1) !important;
}

/* Hero Section */
.hero-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at top right, rgba(24, 144, 255, 0.3) 0%, transparent 70%);
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 60px;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.hero-left {
  flex: 1;
}

.tagline {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.hero-title {
  font-size: 2.8rem;
  line-height: 1.2;
  margin-bottom: 20px;
  font-weight: 700;
}

.hero-title .highlight {
  color: #ffffff;
}

.hero-description {
  font-size: 1.1rem;
  margin-bottom: 30px;
  opacity: 0.9;
  max-width: 600px;
}

.hero-actions {
  display: flex;
  gap: 20px;
}

.explore-btn {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border: none;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 30px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.explore-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

.safe-btn {
  background: linear-gradient(135deg, #1890ff, #0066cc);
  border: none;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 30px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.safe-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

.hero-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.software-showcase {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
  max-width: 400px;
}

.software-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.software-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.software-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  object-fit: cover;
}

.software-info {
  flex: 1;
}

.software-name {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 5px 0;
}

.software-version {
  font-size: 0.8rem;
  opacity: 0.7;
  margin: 0;
}

/* Section Styles */
.section {
  padding: 100px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 15px;
  background: linear-gradient(90deg, #1890ff, #40a9ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-description {
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto;
  opacity: 0.8;
  color: #666;
}

/* Categories Section */
.categories-section {
  background: white;
}

.categories-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 30px;
  padding: 0 20px;
}

.category-card {
  background: rgba(24, 144, 255, 0.05);
  border-radius: 16px;
  padding: 30px 20px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid rgba(24, 144, 255, 0.1);
  cursor: pointer;
}

.category-card:hover {
  transform: translateY(-10px);
  background: rgba(24, 144, 255, 0.1);
  border-color: rgba(24, 144, 255, 0.3);
  box-shadow: 0 10px 30px rgba(24, 144, 255, 0.15);
}

.category-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border-radius: 16px;
  color: white;
}

.category-name {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.category-count {
  font-size: 0.9rem;
  opacity: 0.7;
  margin: 0;
  color: #666;
}

/* Featured Software Section */
.featured-section {
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.05) 0%, rgba(24, 144, 255, 0.05) 100%);
}

.featured-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  padding: 0 20px;
}

.software-item {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(24, 144, 255, 0.1);
}

.software-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(24, 144, 255, 0.2);
}

.software-image {
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e6f7ff, #bae7ff);
}

.software-image img {
  max-width: 100px;
  max-height: 100px;
  border-radius: 12px;
}

.software-details {
  padding: 20px;
}

.software-name {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: #333;
}

.software-desc {
  font-size: 0.9rem;
  color: #666;
  margin: 0 0 15px 0;
  line-height: 1.6;
}

.software-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  font-size: 0.8rem;
  color: #999;
}

.download-btn {
  width: 100%;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border: none;
  padding: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 8px;
  color: white;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);
}

/* Advantages Section */
.advantages-section {
  background: white;
}

.advantages-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  padding: 0 20px;
}

.advantage-card {
  background: rgba(24, 144, 255, 0.05);
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(24, 144, 255, 0.1);
}

.advantage-card:hover {
  transform: translateY(-5px);
  background: rgba(24, 144, 255, 0.1);
  box-shadow: 0 8px 24px rgba(24, 144, 255, 0.2);
}

.advantage-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border-radius: 16px;
  color: white;
}

.advantage-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.advantage-description {
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
}

/* CTA Section */
.cta-section {
  text-align: center;
  padding: 100px 20px;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: white;
}

.cta-section h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 700;
}

.cta-section p {
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto 40px;
  opacity: 0.9;
}

.cta-button {
  background: white;
  color: #1890ff;
  border: none;
  padding: 20px 40px;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

/* Footer */
.footer {
  background: #f0f9ff;
  color: #666;
  text-align: center;
  padding: 30px 0;
  height: auto !important;
  border-top: 1px solid #e6f7ff;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.copyright {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #333;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 30px;
  font-size: 12px;
  color: #999;
  flex-wrap: wrap;
}

/* Responsive */
@media (max-width: 768px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }
  
  .hero-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .hero-title {
    font-size: 2.2rem;
  }
  
  .categories-grid,
  .featured-grid,
  .advantages-grid {
    grid-template-columns: 1fr;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 10px;
  }
  
  .software-showcase {
    max-width: 300px;
  }
}
</style>